import {NgModule} from '@angular/core';
import {XsLibComponent} from './xs-lib.component';
import {ButtonComponent} from './view/button/button.component';
import {LayoutComponent} from './view/layout/layout.component';
import {RadioComponent} from './view/radio/radio.component';
import {CheckboxComponent} from './view/checkbox/checkbox.component';
import {InputComponent} from './view/input/input.component';
import {SelectComponent} from './view/select/select.component';
import {SwitchComponent} from './view/switch/switch.component';
import {TabsComponent} from './view/tabs/tabs.component';
import {TootipComponent} from './view/tootip/tootip.component';
import {MessageComponent} from './view/message/message.component';
import {ModelComponent} from './view/model/model.component';
import {SpinComponent} from './view/spin/spin.component';
import {ConfirmComponent} from './view/confirm/confirm.component';
import {DrawerComponent} from './view/drawer/drawer.component';
import {TableComponent} from './view/table/table.component';
import {EmptyComponent} from './view/empty/empty.component';
import {TreeComponent} from './view/tree/tree.component';
import {DatatimepickerComponent} from './view/datatimepicker/datatimepicker.component';
import {NotificationComponent} from './view/notification/notification.component';
import {MenuComponent} from './view/menu/menu.component';


@NgModule({
  declarations: [
    XsLibComponent,
    ButtonComponent,
    LayoutComponent,
    RadioComponent,
    CheckboxComponent,
    InputComponent,
    SelectComponent,
    SwitchComponent,
    TabsComponent,
    TootipComponent,
    MessageComponent,
    ModelComponent,
    SpinComponent,
    ConfirmComponent,
    DrawerComponent,
    TableComponent,
    EmptyComponent,
    TreeComponent,
    DatatimepickerComponent,
    NotificationComponent,
    MenuComponent
  ],
  imports: [],
  exports: [
    ButtonComponent,
    LayoutComponent,
    RadioComponent,
    CheckboxComponent,
    InputComponent,
    SelectComponent,
    SwitchComponent,
    TabsComponent,
    TootipComponent,
    MessageComponent,
    ModelComponent,
    SpinComponent,
    ConfirmComponent,
    DrawerComponent,
    TableComponent,
    EmptyComponent,
    TreeComponent,
    DatatimepickerComponent,
    NotificationComponent,
    MenuComponent
  ]
})
export class XsLibModule {
}
